module.exports = __webpack_public_path__ + "static/media/8@3x.49ac854a.png";